import useSWR from "swr";

import { MONEY_STATS_API_URL } from "config/backend";
import { ARBITRUM, BSC } from "config/chains";
import { bigNumberify } from "lib/numbers";
import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";

const URL = `${MONEY_STATS_API_URL}/volume/24h`;

export function useVolumeInfo() {
  const { data } = useSWR(
    URL,
    async (url) => {
      const res = await fetch(url);
      const json = await res.json();
      return {
        [ARBITRUM]: bigNumberify(json[ARBITRUM]),
        [BSC]: bigNumberify(json[BSC]),
        total: bigNumberify(json.total),
      };
    },
    {
      refreshInterval: CONFIG_UPDATE_INTERVAL,
    }
  );

  return data;
}
